import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Drawer from '@mui/material/Drawer';
import StockQuickLook from './StockQuickLook.js';
import LaunchIcon from '@mui/icons-material/Launch';

function StockQuickLookDrawer(props) {

    const [drawerOpen, setDrawerOpen] = useState(false);


    return (
        <div>
            <Link className="drawer-link" onClick={() => setDrawerOpen(true)}>{props.symbol} <LaunchIcon fontSize='small' /></Link>
            <Drawer
                anchor={'left'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <div style={{ padding: '20px' }}>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    <br></br>

                    <StockQuickLook symbol={props.symbol} planId={props.planId} mobileView={props.mobileView} role={props.role} />
                    <br></br>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                </div>
            </Drawer>
        </div>
    );
}

export default StockQuickLookDrawer;